import styled from 'styled-components';
import { Popover } from 'antd';

export const StyledPopover = styled(Popover)`
  position: relative;
  .ant-popover-inner {
    padding: 3px;
  }
`;

export const CarouselWrapper = styled.div`
  padding: 20px;
  border-radius: 6px;
  max-width: 500px;
  min-height: 250px;
  color: #333;
  .ant-card {
    height: 100%;
    background: none;
  }
  .ant-carousel .slick-dots-bottom {
    margin: 0px;
  }
  .ant-carousel .slick-dots li button {
    background: #e0e3eb;
  }
  background: rgb(189,223,251);
  background: linear-gradient(180deg,#1D5661 0%,#0C2F3E 75%);
`;

export const CardWrapper = styled.div`
  margin-bottom: 25px;
  height: ${ ({height = 400 }) => height + 'px'};
  .ant-card-meta-detail {
    text-align: center;
  }
  .ant-card-meta-title {
    color: white;
    font-size: 20px;
    font-weight: 600;
  }
  .ant-card-meta-description {
    color: white;
    font-size: 16px;
  }

`;
